import React from "react";

const Formatters = () => {

    const ADMIN_URL = "https://admin.osper.com"
    const JIRA_URL = "https://meetosper.atlassian.net"
    const generic = (tag, value, props = {}) => {
        let children
        if(value instanceof Date) {
            children = value.toISOString()
            props.className = 'datetime'
        } else if (typeof value === 'number') {
            children = value.toFixed(2)
            props.className = 'number'
        } else {
            children = value
        }
        if(tag === 'svg')
            return children
        else
            return React.createElement(tag, props, children)
    }

    const byColumnName = (name) => {
        switch(name){
            case 'card_id': return card_id_link; break;
            case 'account_id': return account_id_link; break;
            case 'parent_id': return account_id_link; break;
            case 'user_id': return account_id_link; break;
            case 'child_id': return account_id_link; break;
            case 'owner_id': return account_id_link; break;
            case 'date_trunc': return isoDate; break;
            case 'date': return isoDate; break;
            case 'month': return isoMonth; break;
            case 'created': return isoDateTime; break;
            case 'note': return long_description; break;
            case 'count': return int; break;
        }
        if(name.endsWith('_id')) return int
        if(name.endsWith('_count')) return int
        if(name.endsWith('_datetime')) return isoDateTime
        if(name.endsWith('_date')) return isoDate
        if(name.endsWith('_description')) return long_description
        return generic
    }

    const isoMonth = (tag, d) => {
        const children = (d instanceof Date) ? d.toISOString().slice(0, 7) : d || ''
        if(tag === 'svg')
            return children
        else
            return React.createElement(tag, {className:'date'}, ...children)
    }

    const isoDate = (tag, d) => {
        const children = (d instanceof Date) ? d.toISOString().slice(0, 10) : d || ''
        if(tag === 'svg')
            return children
        else
            return React.createElement(tag, {className:'date'}, ...children)
    }

    const isoDateTime = (tag, d) => {
        let children = (d instanceof Date) ?
            [
                <span className={"date"}>{ d.toISOString().slice(0, 10) }</span>,
                <span className={"time"}>{ d.toISOString().slice(11, 19) }</span>
            ] : d || ''
        if(tag === 'svg')
            return children
        else
        return React.createElement(tag, {className:'datetime'}, ...children)
    }

    const int = (tag, i) => {
        const children = (typeof i === 'number') ? i.toFixed(0) : i || ""
        return React.createElement(tag, {className:'int'}, ...children)
    }

    const account_id_link = (tag, account_id) => {
        const link = `${ADMIN_URL}/accounts/${account_id}`
        const children = [<a href={link} target="_blank">{account_id}</a>]
        return React.createElement(tag, {className:'int'}, ...children)
    }

    const card_id_link = (tag, card_id='') => {
        const link = `${ADMIN_URL}/cards/${card_id}`
        const children = card_id ?
            [<a href={link} target="_blank">...{card_id.slice(-6)}</a>] :
            [<span></span>]
        return React.createElement(tag, {className:'text'}, ...children)
    }

    const long_description = (tag, txt) => {
        const children = txt ?
            [<span className={"wrappedText"}>{txt.replaceAll("\\"," ")}</span>] : []
        return React.createElement(tag, {className:'text'}, ...children)
    }

    const int_to_bool = (tag, i) => {
        const className = (typeof i === 'number') ? ((i > 0) ? 'bool true' : 'bool false') : ''
        const children = [(typeof i === 'number') ? ((i > 0) ? 'YES' : 'NO') : i]
        return React.createElement(tag, {className:className}, ...children)
    }

    const secondsToHours = (tag, i) => {
       const children = (typeof i === 'number') ? (i / 3600).toFixed(0) : i || ""
        return React.createElement(tag, {className:'int'}, ...children)
    }

    const jira_link = (tag, issue_key) => {
        const link = `${JIRA_URL}/browse/${issue_key}`
        const children = issue_key ?
            [<a href={link} target="_blank">{issue_key}</a>] :
            [<span></span>]
        return React.createElement(tag, {className:'text'}, ...children)
    }

    const progressPercent = (tag, percent) => {
        const rest = 100-percent
        const style = {background: `linear-gradient(90deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.1) ${rest}%, var(--color-base) ${rest}%, var(--color-base) 100%` }
        const children = [<span style={style}>{percent}%</span>]
        return React.createElement(tag, {className:'progressBar'}, ...children)
    }


    return {
        generic :           generic,
        byColumnName :      byColumnName,
        isoDate :           isoDate,
        isoDateTime :       isoDateTime,
        isoMonth :          isoMonth,
        int :               int,
        account_id_link :   account_id_link,
        card_id_link :      card_id_link,
        long_description :  long_description,
        int_to_bool :       int_to_bool,
        secondsToHours:     secondsToHours,
        jira_link:          jira_link,
        progressPercent:    progressPercent
    }
}

export default Formatters